import React from 'react'
import { ParamTemplateRequirement, StepControls } from '@/features/templates'
import Autocomplete from '@/components/ui/Autocomplete'
import { useField } from 'formik'
import Typography from '@/components/ui/Typography'
import { capitalCase } from 'change-case'
import { useCustomObjectKeyOptions } from './ZendeskCustomObjectKeyStep.hooks'

export type ZendeskCustomObjectKeyStepProps = {
  name: string
  requirement: ParamTemplateRequirement
}

export const ZendeskCustomObjectKeyStep = ({ name, requirement }: ZendeskCustomObjectKeyStepProps) => {
  const [, { value }, { setValue }] = useField(name)
  const options = useCustomObjectKeyOptions()

  const onChange = async (fieldName: string, newValue: string) => {
    setValue(newValue)
  }

  return (
    <div style={{ width: 480 }} className={'d-flex flex-column gap-2'}>
      <div>
        <Typography variant={'xxl'}>{capitalCase(name)}</Typography>
        <Typography>{requirement.description}</Typography>
      </div>
      <Autocomplete name={name} value={value} onChange={onChange} options={options} />
      <StepControls disabled={!value} />
    </div>
  )
}
